import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function PaymentCardIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="16"
        viewBox="0 0 24 16"
        fill="none"
      >
        <path d="M1 5H23" stroke={theme.palette.main.professional_blue} strokeWidth="2" />
        <path
          d="M4 9H9.5"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M2.4575 1H21.625C22.3858 1 23 1.52111 23 2.16667V13.8333C23 14.4789 22.3858 15 21.625 15H2.375C1.61417 15 1 14.4789 1 13.8333V2.23667C1 1.89444 1.165 1.59111 1.42167 1.36556C1.6875 1.14 2.05417 1 2.4575 1Z"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
